<template>
  <div class="object-info-item">
    <div v-if="isHtmlText" v-html="content"></div>

    <div v-if="isCoordinate && content.lat" class="object-info-item__coords">
      <div>
        <GmapMap
          :center="content"
          :zoom="16"
          map-type-id="terrain"
          style="width: 500px; height: 300px;"
        >
          <GmapMarker :position="content" />
        </GmapMap>
      </div>

      <div
        v-html="coordinateHtmlValue"
        class="object-info-item__coords_item"
      ></div>
    </div>

    <div v-if="isLookup" v-html="lookupHtmlValue"></div>

    <gallery-carousel v-if="isGallery" :photos="getGalleryPhotos" />

    <template v-if="isProgram">
      <div v-for="(item, index) in content" :key="index">
        <div class="object-info-item__program_title">
          {{ programTitle(item) }}
        </div>

        <div
          class="object-info-item__program_text"
          v-html="item.description"
        ></div>
      </div>
    </template>

    <template v-if="isFile">
      <ul>
        <li
          v-for="(file, index) in content"
          :key="index"
          :title="file.language"
        >
          <a :href="file.url">{{ file.url }}</a>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import * as systemService from "@/domain/object/system.service";
import * as galleryService from "@/domain/object/gallery.service";

export default {
  name: "ObjectInfoItem",
  components: {
    GalleryCarousel: () =>
      import(
        /* webpackChunkName: "galleryCarousel" */ "@/components/library.blocks/GalleryCarousel.vue"
      )
  },
  props: {
    item: Object
  },
  data() {
    return {};
  },
  computed: {
    currentLanguage() {
      return this.$store.state.objectSetting.currentLanguage;
    },
    content() {
      return this.item[this.item.type.toLowerCase()];
    },
    isHtmlText() {
      return systemService.previewAsHtmlText(this.item.type);
    },
    isCoordinate() {
      return systemService.isCoordinate(this.item.type);
    },
    coordinateHtmlValue() {
      if (this.isCoordinate) {
        const getRow = (title, value) => {
          return `<p>${title}: <b>${value}</b></p>`;
        };
        return (
          getRow(this.$t("attr_value_coord_lat"), this.content.lat) +
          getRow(this.$t("attr_value_coord_lng"), this.content.lng)
        );
      }
      return "";
    },
    isLookup() {
      return systemService.isLookUpType(this.item.type);
    },
    lookupHtmlValue() {
      if (this.isLookup) {
        return Array.isArray(this.content)
          ? this.content.map(c => c.name).join(", ")
          : this.content.name || "";
      }
      return "";
    },
    isGallery() {
      return systemService.isGallery(this.item.type);
    },
    isProgram() {
      return systemService.isProgram(this.item.type);
    },
    isFile() {
      return systemService.isFile(this.item.type);
    },
    getGalleryPhotos() {
      return galleryService.getPhotos(this.content, this.currentLanguage);
    }
  },
  methods: {
    programTitle(item) {
      return this.$t("info_program_title", {
        day: item.day,
        cities: item.cities.map(c => c.name).join(", ")
      });
    }
  },
  mounted() {},
  watch: {}
};
</script>

<style lang="scss">
@import "@/css/variables.scss";

.object-info-item {
  .object-info-item__program_title {
    font-weight: 600;
    font-size: 18px;
    color: $primary_color;
  }

  .object-info-item__program_text {
    font-size: 14px;
    margin-bottom: 10px;
    text-align: justify;
  }

  ul {
    padding-left: 40px;
  }

  .object-info-item__coords {
    display: flex;
    justify-content: flex-start;

    .object-info-item__coords_item {
      margin-left: $component_padding_on_left;
    }
  }
}
</style>
